<div class="layout">
  <mat-card class="content-card">
    <mat-card-header>
      <mat-card-title>
        <h5>Annual fees</h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <app-mat-table-generator #matTable [tableName]="'annualFeesTable'"
        [multiselectEnabled]="false" 
        [searchEnabled]="false"
        [columns]="feeColumns" 
        [dataSource]="feeDataSource" 
        [viewLink]="getViewLink">
      </app-mat-table-generator>
    </mat-card-content>
  </mat-card>
</div>
